interface EphiIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

export function EphiIcon({ className, ...props }: EphiIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 203.84 396.77"
      className={className}
      {...props}
    >
      <path
        style={{ fill: 'currentColor', opacity: 0.8 }}
        d="M103.5 277.01 0 253.01 91.13 37.03l12.37 239.98z"
      />
      <path
        style={{ fill: 'currentColor', opacity: 0.9 }}
        d="m191.29 148.49-69.75 91.5L109.17 0l82.12 148.49z"
      />
      <path
        style={{ fill: 'currentColor', opacity: 0.7 }}
        d="m203.09 308.45-86.25-32.25 69.75-91.5 16.5 123.75z"
      />
      <path
        style={{ fill: 'currentColor', opacity: 1 }}
        d="M109.16 286.54c.13.37-1.5 95.25-1.5 95.25l-102-119.25 103.5 24Z"
      />
      <path
        style={{ fill: 'currentColor', opacity: 0.85 }}
        d="m203.84 333.77-87.75 63 1.5-95.25 86.25 32.25z"
      />
    </svg>
  )
} 